import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ApiHelperService } from './api-helper.service';
import { ApiService } from './api.service';
import { ApiUrlPipe, ApiUrlUnpurePipe } from './api-url.pipe';

export function API_DEFAULT_OPTIONS_FACTORY(): ApiModuleConfig {
  return {
    apiUrl: '',
    apiEdgeUrl: '',
  };
}

export const API_DEFAULT_OPTIONS = new InjectionToken<ApiModuleConfig>(
  'mat-tooltip-default-options',
  {
    providedIn: 'root',
    factory: API_DEFAULT_OPTIONS_FACTORY,
  },
);

export class ApiModuleConfig {
  apiUrl = '';
  apiEdgeUrl?: string = '';
  apiEdgeMax?: number = 0;
}

@NgModule({
  declarations: [ApiUrlPipe, ApiUrlUnpurePipe],
  exports: [ApiUrlPipe, ApiUrlUnpurePipe],
  imports: [CommonModule, FormsModule, RouterModule],
  providers: [
    ApiUrlPipe,
    ApiUrlUnpurePipe,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class ApiModule {
  public static forRoot(): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [ApiService, ApiHelperService, provideHttpClient(withFetch())],
    };
  }
}
